module.exports = __webpack_public_path__ + "img/platform-2.88d1b54c.png";